import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state';
import { MITInflowSearchResult } from 'src/app/state/missing-in-tracy/missing-in-tracy.reducers';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatChipsModule,
        MatSortModule
    ],
    selector: 'app-MIT-inflow',
    templateUrl: './missing-in-tracy-inflow.component.html',
    styleUrls: ['./missing-in-tracy-inflow.component.scss']
})
export class MITInflowComponent {
    displayedColumns: string[] =
        [
            'period',
            'totalMIT',
            'remainingMIT',
            'percentHealed',
        ];

    @Input() MITInflowResult: MITInflowSearchResult;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    constructor(private store: Store<AppState>) { }
}
